/*
 * DaisyBee Arts — live cart count
 *
 * Keeps the "(0)" beside Bag in step with the cart without a page load, by
 * listening to the same event Horizon's own cart components use.
 *
 * Deliberately its own file: it depends on the theme's import map, which only
 * exists inside Shopify. If that import ever fails, this module is the only
 * thing that stops working — the count still renders correctly from Liquid on
 * every page load, it just would not update in place.
 */

import { StandardEvents } from '@shopify/events';

const format = (count) => `(${count})`;

async function refresh() {
  const targets = document.querySelectorAll('[data-db-cart-count]');
  if (targets.length === 0) return;

  try {
    const response = await fetch(`${window.Shopify?.routes?.root ?? '/'}cart.js`);
    if (!response.ok) return;

    const cart = await response.json();
    for (const el of targets) el.textContent = format(cart.item_count);
  } catch {
    // Offline or blocked — leave the server-rendered count alone.
  }
}

document.addEventListener(StandardEvents.cartLinesUpdate, refresh);
window.addEventListener('pageshow', refresh);
